var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"input"},[_c('div',{staticClass:"title"},[_vm._v(_vm._s(_vm.info.is_required=='1'?'*':'')+" "+_vm._s(_vm.info.name))]),_c('el-input',{staticClass:"input_input",attrs:{"type":"text","placeholder":_vm.info.placeholder,"size":"small"},model:{value:(_vm.text),callback:function ($$v) {_vm.text=$$v},expression:"text"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }